import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  duration: string;
  views: string;
  rating: number;
  imageUrl: string;
  isNew?: boolean;
}

export default function VideoCard({
  id,
  title,
  category,
  duration,
  views,
  rating,
  imageUrl,
  isNew,
}: VideoCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-video overflow-hidden bg-background-100">
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
        <span className="absolute bottom-2 right-2 bg-black/70 text-background-50 text-xs px-1.5 py-0.5 rounded">
          {duration}
        </span>
        {isNew && (
          <span className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-full font-medium">
            新上线
          </span>
        )}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <div className="w-12 h-12 flex items-center justify-center bg-primary-500/90 rounded-full">
            <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug mb-1.5 group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-xs text-secondary-600 bg-secondary-100 px-1.5 py-0.5 rounded">
              {category}
            </span>
            <span className="text-xs text-foreground-400">{views}次播放</span>
          </div>
          <div className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            <span className="text-xs text-foreground-500 font-medium">{rating}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}